export default function TAHome() {
  return (
    <div>
      <h1 className="header-home">Welcome to Home TA</h1>
    </div>
  );
}
